/**
 * Adapter that maps shadcn Button variant/size values to IntuiButton equivalents.
 * Used by the uiv2 feature flag to swap Button implementations transparently.
 */
import * as React from 'react'
import { IntuiButton, type IntuiButtonProps } from '@/components/intueri/IntuiButton/IntuiButton'

import type { ButtonProps } from './button'

/** Map shadcn-only variants to the closest Intui variant */
const VARIANT_MAP: Record<string, IntuiButtonProps['variant']> = {
  icon: 'default',
  tabInactive: 'ghost',
  tabActive: 'outline',
}

/** Map shadcn-only sizes to the closest Intui size */
const SIZE_MAP: Record<string, IntuiButtonProps['size']> = {
  xl: 'lg',
}

const ButtonV2Adapter = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant, size, style: _style, onMouseEnter: _onMouseEnter, onMouseLeave: _onMouseLeave, ...props }, ref) => {
    const mappedVariant = (variant && VARIANT_MAP[variant]) ?? variant as IntuiButtonProps['variant']
    const mappedSize = (size && SIZE_MAP[size]) ?? size as IntuiButtonProps['size']

    return <IntuiButton ref={ref} variant={mappedVariant} size={mappedSize} {...props} />
  },
)
ButtonV2Adapter.displayName = 'Button'

export { ButtonV2Adapter }
